import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { API, API_ROUTES } from '@app/shared/utils/api-routes';
import { Observable } from 'rxjs';
import { SettingsBody } from '@app/components/settings/settings.model';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  constructor(private httpClient: HttpClient) {}

  public postSettings(settings: SettingsBody): Observable<unknown> {
    return this.httpClient.post(`${environment.BA_API_BASE_URL}${API.PPA}${API_ROUTES.SETTINGS}`, settings, {
      headers: {
        'Content-Type': 'application/json',
      },
    }) as Observable<unknown>;
  }

  public getSettings(): Observable<{ quota: number; threshold: number }> {
    return this.httpClient.get<{ quota: number; threshold: number }>(
      `${environment.BA_API_BASE_URL}${API.PPA}${API_ROUTES.SETTINGS}`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
  }
}
